import type { SSEEvent } from "./types";

export function parseSSEChunk(chunk: string): SSEEvent[] {
  const out: SSEEvent[] = [];
  for (const block of chunk.split("\n\n")) {
    if (!block.trim()) continue;
    let event: string | null = null;
    let data: string | null = null;
    for (const line of block.split("\n")) {
      if (line.startsWith("event:")) event = line.slice(6).trim();
      else if (line.startsWith("data:")) data = line.slice(5).trim();
    }
    if (!event || !data) continue;
    try {
      const payload = JSON.parse(data);
      out.push({ type: event, ...payload } as SSEEvent);
    } catch {
      // skip malformed
    }
  }
  return out;
}

export async function fetchConsent(site: string, visitor_id: string): Promise<string> {
  const res = await fetch(`${__BACKEND_BASE__}/consent`, {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify({ site, visitor_id, ai_disclosure: true, cookies: true }),
  });
  if (!res.ok) throw new Error(`consent failed: ${res.status}`);
  const json = (await res.json()) as { consent_token: string };
  return json.consent_token;
}

export async function* streamChat(args: {
  site: string;
  visitor_id: string;
  conversation_id: string | null;
  message: string;
  consent_token: string;
}): AsyncGenerator<SSEEvent> {
  const res = await fetch(`${__BACKEND_BASE__}/chat`, {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify(args),
  });
  if (!res.ok || !res.body) throw new Error(`chat failed: ${res.status}`);
  const reader = res.body.getReader();
  const dec = new TextDecoder();
  let buf = "";
  while (true) {
    const { value, done } = await reader.read();
    if (done) break;
    buf += dec.decode(value, { stream: true });
    const lastBoundary = buf.lastIndexOf("\n\n");
    if (lastBoundary === -1) continue;
    const chunk = buf.slice(0, lastBoundary + 2);
    buf = buf.slice(lastBoundary + 2);
    for (const ev of parseSSEChunk(chunk)) yield ev;
  }
}
